export const animationSettings = {
  animAdd: {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', false],
    'STATE:OUT:FS-ADD': ['static'],
  },
  animAddport: {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', false],
    'STATE:OUT:FS-ADD': ['static'],
  },
}
